import { combineReducers, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isNumber } from "lodash";
import { apiRequest } from "services/ServiceUtil";
import { NOTIFICATION_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";
import { NotificationState } from "./Notifications";

const SLICE = "Notifications";

const initialState: NotificationState = {
  list: [],
  unreadNotifications: 0,
  notifiedByList: [],
  isLoading: false
};

export const fetchUsersAsync = createAsyncThunk(`${SLICE}/fetchUsersAsync`, (data: any, thunkApi) =>
  apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], data)
);

export const getNotifications = createAsyncThunk(`${SLICE}/getNotifications`, (data: any, thunkApi: any) =>
  apiRequest(NOTIFICATION_SERVICE_METHOD.getNotifications, {}, thunkApi, [], data)
);

export const putNotifications = createAsyncThunk(`${SLICE}/putNotifications`, (data: any, thunkApi: any) =>
  apiRequest(NOTIFICATION_SERVICE_METHOD.putNotifications, data, thunkApi, [])
);

export const deleteNotifications = createAsyncThunk(`${SLICE}/deleteNotifications`, (data: any, thunkApi) =>
  apiRequest(NOTIFICATION_SERVICE_METHOD.deleteNotifications, {}, thunkApi, [], data)
);

export const NotificationsSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotifications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNotifications.fulfilled, (state, action: any) => {
        state.list = action.payload.notifications;
        state.unreadNotifications = action.payload.notifications.filter((item: any) => item.isRead === "N").length;
        if (!action.payload.notifications.length) {
          state.isLoading = false;
        }
      })
      .addCase(fetchUsersAsync.fulfilled, (state, action: any) => {
        state.notifiedByList = action.payload.users;
        state.isLoading = false;
      })
      .addCase(getNotifications.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(putNotifications.fulfilled, (state, action: any) => {
        state.list = action.payload.notifications;
        state.unreadNotifications = action.payload.notifications.filter((item: any) => item.isRead === "N").length;
      })
      .addCase(deleteNotifications.fulfilled, (state, action: any) => {
        if (!isNumber(action.meta?.arg?.notificationIds)) {
          state.list = [];
          state.unreadNotifications = 0;
        } else {
          state.list = state.list.filter((item: any) => item.id !== action.meta?.arg?.notificationIds);
          state.unreadNotifications = state.list.filter((item: any) => item.isRead === "N").length;
        }
      });
  }
});

const rootReducer = combineReducers({
  data: NotificationsSlice.reducer
});

export default rootReducer;
